import { AppliedConstraintCoreBase } from "./applied-constraint.core.base"


export class AppliedConstraintCore extends AppliedConstraintCoreBase {

}